export default __webpack_public_path__ + "static/media/login-option-facebook.e04e777a.svg";